export function registerServiceWorker() {
	if (!("serviceWorker" in navigator)) return;

	if (!import.meta.env.PROD) {
		void navigator.serviceWorker
			.getRegistrations()
			.then((registrations) => {
				for (const registration of registrations) {
					void registration.unregister();
				}
			})
			.catch(() => undefined);
		return;
	}

	window.addEventListener("load", () => {
		void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((error) => {
			console.warn("OBLIQ service worker registration failed", error);
		});
	});
}
